// extracted by mini-css-extract-plugin
export default {"sidenav":"style_sidenav__+H06a","nav_link":"style_nav_link__fZ9bN","active":"style_active__GA6vI"};